import React, { useContext } from 'react'
import { Box, LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import RightTickImg from '../assets/right_tick_img.svg'
import BottomSheetModel from './bottomSheetModal';
import { GlobalStateContext } from '../context/globalStateProvider';

const Activities = (props) => {
    const { viewAllActivities, setViewAllActivities} = useContext(GlobalStateContext)
    const { activities, currentActivity, activitiesPercentage } = props
    const theme = useTheme();

    return (
        <BottomSheetModel title="Valet Status" isOpen={viewAllActivities} onClose={() => setViewAllActivities(false)} style={{height:"70svh"}} >
            <Box sx={theme.customStyles.valetActivitiesContainer}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop:"24px" }}>
                    <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium }}>{currentActivity.name}</Box>
                </Box>

                <Box sx={{ marginTop: "8px" }}>
                    <LinearProgress variant="determinate" value={activitiesPercentage} />
                </Box>

                <Box sx={{ marginTop: "16px", borderRadius: "8px", border: "1px solid #EFEFEF", padding: "16px" }}>
                    {
                        activities.map((activity, i) => (
                            <Box key={i} sx={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                    <Box sx={{ ...theme.customStyles.circle, backgroundColor: activity.timestamp ? "#24A147" : "#DCDCDC" }}>
                                        {activity.timestamp
                                            ? <img src={RightTickImg} alt='Right Tick' width={15} height={12} />
                                            : <Box sx={{ color: theme.palette.lightGray.main, fontSize: "14px", fontWeight: theme.typography.fontWeightRegular }}>{i + 1}</Box>
                                        }
                                    </Box>
                                    {activities.length !== i + 1 && <Box sx={theme.customStyles.verticalLine}></Box>}
                                </Box>
                                <Box sx={{ marginLeft: "8px", marginTop: !activity.timestamp ? "5px" : "0px" }}>
                                    <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium }}>{activity.name}</Box>
                                    {activity.timestamp && <Box sx={{ color: theme.palette.lightGray.main, fontSize: "11px", fontWeight: theme.typography.fontWeightMedium }}>{moment(activity.timestamp).format('MMM D, YYYY • h:mm A')}</Box>}
                                </Box>
                            </Box>
                        ))
                    }
                </Box>
            </Box>
        </BottomSheetModel>
    )
}

export default Activities